/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

// Base
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHECK = "CHECK";
export const SERVICE_TEST = "SERVICE_TEST";
export const AUTHENTICATED = "AUTHENTICATED";
export const GET_HOME_CUSTOM_TOTAL = "GET_HOME_CUSTOM_TOTAL";
export const GET_HOME_BUSI = "GET_HOME_BUSI";
export const GET_HOME_CONTRACT = "GET_HOME_CONTRACT";
export const GET_HOME_CUSTOM_VISIT = "GET_HOME_CUSTOM_VISIT";
export const GET_HOME_CHART_DATA = "GET_HOME_CHART_DATA";
export const GET_HOME_PROJECT = "GET_HOME_PROJECT";
export const GET_HOME_MEDICAL_CUSTOMER = "GET_HOME_MEDICAL_CUSTOMER";

// 审核
export const GET_CLIENT_TYPE = "GET_CLIENT_TYPE";
export const GET_CLIENT_AUDIT_LIST = "GET_CLIENT_AUDIT_LIST";
export const GET_CLIENT_AUDIT_DETAIL = "GET_CLIENT_AUDIT_DETAIL";
export const GET_AUDIT_CONTACTS_LIST = "GET_AUDIT_CONTACTS_LIST";

// 权限管理
export const GET_CRM_ROLE = "GET_CRM_ROLE";
export const GET_CRM_OPERATION_MENU = "GET_CRM_OPERATION_MENU";
export const GET_CRM_DATA_MENU = "GET_CRM_DATA_MENU";
export const GET_AUTHORITY = "GET_AUTHORITY"; // 用户权限
export const GET_USERINFO = "GET_USERINFO"; // 用户信息
export const GET_CUSTOM_AUTH = "GET_CUSTOM_AUTH"; // 客户信息相关权限
export const GET_MEDICALCUSTOM_AUTH = "GET_MEDICALCUSTOM_AUTH"; // 客户信息相关权限
export const GET_QUICK_ADD_AUTH = "GET_QUICK_ADD_AUTH"; // 快捷新增相关权限
export const GET_PRODUCT_MANAGE_AUTH = "GET_PRODUCT_MANAGE_AUTH"; // 产品线管理权限
export const GET_VISIT_AUTH = "GET_VISIT_AUTH"; // 拜访管理权限
export const GET_CONTRACT_AUTH = "GET_CONTRACT_AUTH"; // 合同权限
export const GET_BUSINESS_AUTH = "GET_BUSINESS_AUTH"; // 商机权限

// 后台
export const GET_CRM_USERS = "GET_CRM_USERS";
export const GET_TEAM_LIST = "GET_TEAM_LIST";
export const GET_PARENT_TEAM_LIST = "GET_PARENT_TEAM_LIST";
export const GET_TEAM_MEMBERS = "GET_TEAM_MEMBERS";
export const GET_RECORDS = "GET_RECORDS";
export const GET_DICTIONARY_LIST = "GET_DICTIONARY_LIST";
export const GET_DICTIONARY_DETAIL_LIST = "GET_DICTIONARY_DETAIL_LIST";
export const GET_DICTIONARY_DETAIL = "GET_DICTIONARY_DETAIL";
export const GET_TEAM_CONFIG_LIST = "GET_TEAM_CONFIG_LIST";
export const GET_SECOND_TEAM_LIST = "GET_SECOND_TEAM_LIST";
export const GET_ALL_CATEGORY_LIST = "GET_ALL_CATEGORY_LIST";
export const GET_ALL_DICTIONARY_LIST = "GET_ALL_DICTIONARY_LIST";
export const GET_TEAM_CONFIG_DETAIL = "GET_TEAM_CONFIG_DETAIL";
export const GET_CRM_TEAM_LIST = "GET_CRM_TEAM_LIST";
export const GET_TEAM_CHANGE = "GET_TEAM_CHANGE";
export const GET_ROLE_LIST = "GET_ROLE_LIST";
export const GET_ROLE_USER_LIST = "GET_ROLE_USER_LIST";

// 商机管理
export const GET_BUSI_STAGE_LIST = "GET_BUSI_STAGE_LIST";
export const GET_BUSI_OPPORTUNITY_LIST = "GET_BUSI_OPPORTUNITY_LIST";
export const GET_CUSTOM_SELECT_DATA = "GET_CUSTOM_SELECT_DATA";
export const GET_BUSI_OPPORTUNITY_DETAIL = "GET_BUSI_OPPORTUNITY_DETAIL";
export const GET_BUSI_VISIT_DATA = "GET_BUSI_VISIT_DATA";
export const GET_BUSI_SALES_DATA = "GET_BUSI_SALES_DATA";
export const GET_BUSI_FILE_DATA = "GET_BUSI_FILE_DATA";
export const GET_BUSI_LINE_LIST = "GET_BUSI_LINE_LIST";
export const GET_BUSI_SALES_LIST = "GET_BUSI_SALES_LIST";
export const GET_BUSI_CONTACT_LIST = "GET_BUSI_CONTACT_LIST";
export const GET_BUSI_DETAIL_CONTACT_LIST = "GET_BUSI_DETAIL_CONTACT_LIST";
// 公共模块
export const GET_PROJECT_NAME = "GET_PROJECT_NAME";
export const GET_PROJECT_STATUS = "GET_PROJECT_STATUS";
export const GET_CUSTOM_NAME = "GET_CUSTOM_NAME";
export const GET_VISIT_INTERVAL = "GET_VISIT_INTERVAL";
export const GET_VISIT_PEOPLE = "GET_VISIT_PEOPLE";
export const GET_VISIT_TYPE = "GET_VISIT_TYPE";
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
export const SET_PRODUCT_LIST_LOADING = "SET_PRODUCT_LIST_LOADING";
export const SET_USER_LIST = "SET_USER_LIST";
export const GET_USER_ADMIN = "GET_USER_ADMIN";
export const GET_DOCTOR_TITLE = "GET_DOCTOR_TITLE";
export const GET_HOSPITAL_LEVEL = "GET_HOSPITAL_LEVEL";
export const GTE_AUDITIONG_APPLY = "GTE_AUDITIONG_APPLY";
export const GET_HOME_CUSTOM = "GET_HOME_CUSTOM";
export const GET_SERVICE_LINES = "GET_SERVICE_LINES";
export const GET_USER_TEAMID = "GET_USER_TEAMID";
export const GET_CRM_AUTH = "GET_CRM_AUTH";
export const GET_SIGNIN_TEAMS = "GET_SIGNIN_TEAM";
export const GET_SERVICE_TYPE = "GET_SERVICE_TYPE";
export const GET_CLUE_SOURCE = "GET_CLUE_SOURCE";
export const GET_INVALID_REASON = "GET_INVALID_REASON";
export const GET_INVESTIGATION_NATURE = "GET_INVESTIGATION_NATURE";
export const GET_INVESTIGATION_CATEGORY = "GET_INVESTIGATION_CATEGORY";
export const GET_RECEPTION_LEVEL = "GET_RECEPTION_LEVEL";
export const GET_GOVERNMENT_DETAIL = "GET_GOVERNMENT_DETAIL";
export const GET_PROJECT_STAGE = "GET_PROJECT_STAGE";
export const GET_MODE_TYPE = "GET_MODE_TYPE";
export const GET_SETTLEMENT_SOURCE = "GET_SETTLEMENT_SOURCE";
export const GET_CUSTOM_LEVEL = "GET_CUSTOM_LEVEL";

// 合同管理
export const GET_COMPACT_LIST = "GET_COMPACT_LIST";
export const GET_COMPACT_COUNT = "GET_COMPACT_COUNT";
export const GET_COMPACT_TYPE_LIST = "GET_COMPACT_TYPE_LIST";
export const GET_SERVICE_CONTENT_LIST = "GET_SERVICE_CONTENT_LIST";
export const GET_SETTLEMENT_TYPE_LIST = "GET_SETTLEMENT_TYPE_LIST";
export const GET_BUSI_SELECT_DATA = "GET_BUSI_SELECT_DATA";
export const GET_COMPACT_CUSTOM_SELECT_DATA = "GET_COMPACT_CUSTOM_SELECT_DATA";
export const GET_COMPACT_DETAIL = "GET_COMPACT_DETAIL";
export const GET_COMPACT_RETURND_RECORD = "GET_COMPACT_RETURND_RECORD";
export const GET_COMPACT_RETURND_RECORD_DETAIL =
  "GET_COMPACT_RETURND_RECORD_DETAIL";
export const GET_COMPACT_BILLS_RECORD = "GET_COMPACT_BILLS_RECORD";
export const GET_COMPACT_BILLS_RECORD_DETAIL =
  "GET_COMPACT_BILLS_RECORD_DETAIL";
export const GET_COMPACT_FILE_LIST = "GET_COMPACT_FILE_LIST";
export const GET_SALESMAN_TABLE_DATA = "GET_SALESMAN_TABLE_DATA";
export const GET_BUSI_LINE_TABLE_DATA = "GET_BUSI_LINE_TABLE_DATA";
export const GET_CUSTOM_CLASSIFY_TABLE_DATA = "GET_CUSTOM_CLASSIFY_TABLE_DATA";
export const GET_DEPA_BUSILINE_TABLE_DATA = "GET_DEPA_BUSILINE_TABLE_DATA";
export const GET_THREE_BUSILINE_TABLE_DATA = "GET_THREE_BUSILINE_TABLE_DATA";
export const GET_DEPARTMENT_TABLE_DATA = "GET_DEPARTMENT_TABLE_DATA";
export const GET_CUS_INSURANCE_TABLE_DATA = "GET_CUS_INSURANCE_TABLE_DATA";
export const GET_CUS_BANK_TABLE_DATA = "GET_CUS_BANK_TABLE_DATA";
export const GET_CUS_HEALTH_MANAGEMENT_TABLE_DATA =
  "GET_CUS_HEALTH_MANAGEMENT_TABLE_DATA";
export const GET_CUS_INTERNET_TABLE_DATA = "GET_CUS_INTERNET_TABLE_DATA";
export const GET_CUS_OPRATION_TABLE_DATA = "GET_CUS_OPRATION_TABLE_DATA";
export const GET_COMPACT_COST_LIST = "GET_COMPACT_COST_LIST";
export const GET_COMPACT_COST_TYPE = "GET_COMPACT_COST_TYPE";
export const GET_DEP30F_BUS_PERFORMANCE_TABLE_DATA =
  "GET_DEP30F_BUS_PERFORMANCE_TABLE_DATA";
export const GET_CUSTOMER_REVENUE_TABLE_DATA =
  "GET_CUSTOMER_REVENUE_TABLE_DATA";
export const GET_COPRATION_DEPARTMENT = "GET_COPRATION_DEPARTMENT";
export const GET_COMPACT_TEAM = "GET_COMPACT_TEAM"; // 合同团队
export const GET_SIGNING_FORM_LIST = "GET_SIGNING_FORM_LIST";
export const GET_COMPACT_SALESMAN = "GET_COMPACT_SALESMAN";
export const GET_MONEY_BACK_DATA = "GET_MONEY_BACK_DATA";
export const GET_COST_DATA_LIST = "GET_COST_DATA_LIST";
export const GET_PAY_DATA_LIST = "GET_PAY_DATA_LIST";
export const GET_COMPACT_PAY_TYPE = "GET_COMPACT_PAY_TYPE";
export const GET_MONEY_SPEND_DATA = "GET_MONEY_SPEND_DATA";
export const GET_SPEND_SALES = "GET_SPEND_SALES";
export const GET_SPEND_DETAIL = "GET_SPEND_DETAIL";

// 客户
export const GET_CUSTOMDETAIL = "GETCUSTOMDETAIL";
export const GET_CUSTOMNAME = "GETCUSTOMNAME";
export const GET_CUSTOM_LIST = "GET_CUSTOM_LIST";
export const GET_MEDICAL_CUSTOM_LIST = "GET_MEDICAL_CUSTOM_LIST";
export const GET_PROJECT_LIST = "GET_PROJECT_LIST";
export const GET_CUSTOM_APPLY_LIST = "GET_CUSTOM_APPLY_LIST";
export const GET_CLERK_LIST = "GET_CLERK_LIST";
export const GET_CUSTOM_CONTACTS = "GET_CUSTOM_CONTACTS";
export const GET_CUSTOM_VISITS = "GET_CUSTOM_VISITS";
export const GET_CUSTOM_BUSI = "GET_CUSTOM_BUSI";
export const GET_CUSTOM_COMPACT = "GET_CUSTOM_COMPACT";
export const GET_CUSTOM_HOSPITAL_LEVEL = "GET_CUSTOM_HOSPITAL_LEVEL";
export const GET_CUSTOM_FOLLOW_UP = "GET_CUSTOM_FOLLOW_UP";
export const GET_CUSTOM_TYPE = "GET_CUSTOM_TYPE";
export const GET_CONTACTS_TYPE = "GET_CONTACTS_TYPE";
export const GET_DOCTOR_LIST = "GET_DOCTOR_LIST";
export const GET_OPERATOR_LIST = "GET_OPERATOR_LIST";
export const GET_DOCTOR_ARCHIVE_LIST = "GET_DOCTOR_ARCHIVE_LIST";
export const GET_CUSTOM_ARCHIVE_LIST = "GET_CUSTOM_ARCHIVE_LIST";
export const GET_CUSTOM_SALESMAN = "GET_CUSTOM_SALESMAN";
export const GET_FINALLY_CUSTOM = "GET_FINALLY_CUSTOM";
export const GET_REFUSED_CUSTOMER = "GET_REFUSED_CUSTOMER";
export const GET_GOVERNMENT_DATA = "GET_GOVERNMENT_DATA";
export const GET_GOVERNMENT_BUSILINE = "GET_GOVERNMENT_BUSILINE";
export const GET_INVESTIGATION_PERSON = "GET_INVESTIGATION_PERSON";
export const GET_PROJECT_DATA = "GET_PROJECT_DATA";
export const GET_PROFOLLOW_DATA = "GET_PROFOLLOW_DATA";
export const GET_TEAM_SELECT = "GET_TEAM_SELECT";
export const GET_CUSTOM_PROJECT = "GET_CUSTOM_PROJECT";
export const GET_CUSTOMER_HOLD = "GET_CUSTOMER_HOLD";
export const GET_CUSTOM_TYPE_NO_DOC = "GET_CUSTOM_TYPE_NO_DOC";
// 拜访管理
export const GET_VISIT_LIST = "GET_VISIT_LIST";
export const GET_VISIT_DETAIL = "GET_VISIT_DETAIL";
export const GET_STATISTICS_VISIT_TYPE = "GET_STATISTICS_VISIT_TYPE";
export const GET_VISIT_TEAMS = "GET_VISIT_TEAM";
export const GET_VISIT_CUSTOMER_DATA_LIST = "GET_VISIT_CUSTOMER_DATA_LIST";
export const GET_VISIT_MEDICAL_CUSTOMER_DATA_LIST =
  "GET_VISIT_MEDICAL_CUSTOMER_DATA_LIST";
export const GET_VISIT_CUSTOMER_SALESMAN_DATA_LIST =
  "GET_VISIT_CUSTOMER_SALESMAN_DATA_LIST";
export const GET_VISIT_CUSTOMER_CONVERT_DATA_LIST =
  "GET_VISIT_CUSTOMER_CONVERT_DATA_LIST";
export const GET_VISIT_BUSINESS_DATA_LIST = "GET_VISIT_BUSINESS_DATA_LIST";
export const GET_VISIT_BUSINESS_CONVERT_DATA_LIST =
  "GET_VISIT_BUSINESS_CONVERT_DATA_LIST";
export const GET_VISIT_CLUES_DATA_LIST = "GET_VISIT_CLUES_DATA_LIST";

// 数据统计
export const GET_SIGN_IN_LIST = "GET_SIGN_IN_LIST";
export const GET_SIGN_IN_DETAIL = "GET_SIGN_IN_DETAIL";
export const GET_TIMING_RECORD_LIST = "GET_TIMING_RECORD_LIST";
export const GET_TIMING_RECORD_TEAMS = "GET_TIMING_RECORD_TEAMS";
export const GET_TIMING_RECORD_DETAIL = "GET_TIMING_RECORD_DETAIL";
export const GET_PRO_ONLINE_TOP = "GET_PRO_ONLINE_TOP";
export const GET_PRO_OFFLINE_TOP = "GET_PRO_OFFLINE_TOP";
export const GET_TEL_COUNSELING = "GET_TEL_COUNSELING";
export const GET_OFFLINE_SERVICE = "GET_OFFLINE_SERVICE";
export const GET_CUSTOM_SELECT = "GET_CUSTOM_SELECT";
export const GET_DOCTEL_CONNECTION = "GET_DOCTEL_CONNECTION";
export const GET_STATISTICS_TEAM_LIST = "GET_STATISTICS_TEAM_LIST";

// 线索
export const GET_CLUE_LIST = "GET_CLUE_LIST";
export const GET_CLUE_SALESMAN = "GET_CLUE_SALESMAN";
export const GET_CLUE_DETAIL = "GET_CLUE_DETAIL";
export const GET_SEARCH_CUSTOMER = "GET_SEARCH_CUSTOMER";
export const GET_TRANSFER_DETAIL = "GET_TRANSFER_DETAIL";
export const GET_CLUE_VISIT = "GET_CLUE_VISIT";

// 知识库
export const GET_KNOW_LIST = "GET_KNOW_LIST";
export const GET_KNOW_TREE = "GET_KNOW_TREE";
export const GET_KNOW_DETAIL = "GET_KNOW_DETAIL";
export const GET_KNOW_TEAM = "GET_KNOW_TEAM";
export const GET_KNOW_FILELIST = "GET_KNOW_FILELIST";

// 项目
export const GET_PROJECT_TEAM = "GET_PROJECT_TEAM";
export const GET_PROJECT_DATALIST = "GET_PROJECT_DATALIST";
export const GET_PROJECT_DETAIL = "GET_PROJECT_DETAIL";
export const GET_CRM_PROJECT_DATALIST = "GET_CRM_PROJECT_DATALIST";
export const GET_PROJECT_LIST_SELECT = "GET_PROJECT_LIST_SELECT";
export const GET_PROJECT_CUSTOMER = "GET_PROJECT_CUSTOMER";
export const GET_PROJECT_CUSTOMER_SELECT = "GET_PROJECT_CUSTOMER_SELECT";
export const GET_PROJECT_CONTRACT_SELECT = "GET_PROJECT_CONTRACT_SELECT";
export const GET_PROJECT_SALESMAN_SELECT = "GET_PROJECT_SALESMAN_SELECT";
export const GET_PROJECT_PACKAGELIST = "GET_PROJECT_PACKAGELIST";

// 菜单
export const GET_MENU_TREE_LIST = "GET_MENU_TREE_LIST";

// 产品线管理
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
